const validators = {
  checkNumber: function (value) {
    if (value != null && value !== '' && !/^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value)) {
      return false
    } else {
      return true
    }
  },
  checkInteger: function (value) {
    if (value != null && value !== '' && !/^-?\d+$/.test(value)) {
      return false
    } else {
      return true
    }
  },
  checkMobile: function (value) {
    if (value && !(/^(1[3-9]\d{9})$|^(\d{8})$|^(\d{9})$/.test(value))) {
      return false
    } else {
      return true
    }
  },
  checkEmail: function (value) {
    if (value != null && value !== '' && !/^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value)) {
      return false
    } else {
      return true
    }
  },
  checkPassword: function (value) {
    let reg = /^(?![0-9a-z]+$)(?![0-9A-Z]+$)(?![0-9\W]+$)(?![a-z\W]+$)(?![a-zA-Z]+$)(?![A-Z\W]+$)[a-zA-Z0-9\W_]+$/
    // let reg = /^(?![A-Za-z]+$)(?![A-Z\\d]+$)(?![A-Z\\W]+$)(?![a-z\\d]+$)(?![a-z\\W]+$)(?![\\d\\W]+$)\\S{8,12}$/
    //     /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[#@*&.]).{8,20}$/
    //     let reg =/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d).{8,20}$/;
    if (!reg.test(value)) {
      return false
    } else {
      if (value.length < 8 || value.length > 12) {
        return false
      } else {
        return true
      }
    }
  }
}

export default validators
